export const NOTIFICATIONS_CENTER_DROPDOWN_ID = 'notifications_center_dropdown';
export const SCROLL_AREA_CLASSNAME = 'notifications-center-list-scroll-area';
